import { render, staticRenderFns } from "./sponser-member-add-new.vue?vue&type=template&id=1596f85a&scoped=true&"
import script from "./sponser-member-add-new.vue?vue&type=script&lang=js&"
export * from "./sponser-member-add-new.vue?vue&type=script&lang=js&"
import style0 from "./sponser-member-add-new.vue?vue&type=style&index=0&id=1596f85a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596f85a",
  null
  
)

component.options.__file = "sponser-member-add-new.vue"
export default component.exports